// Small building blocks shared by the Numbers page and its Day view.
import { useAppColors } from '@/src/lib/theme';

export const GOLD = '#E8A020';
export const RED = '#DC2626';

// Columns that keep rows full for however many cards are showing.
export function gridCols(n: number): string {
  const lg: Record<number, string> = { 1: 'lg:grid-cols-1', 2: 'lg:grid-cols-2', 3: 'lg:grid-cols-3', 4: 'lg:grid-cols-4', 5: 'lg:grid-cols-5', 6: 'lg:grid-cols-3', 7: 'lg:grid-cols-4', 8: 'lg:grid-cols-4', 9: 'lg:grid-cols-5', 10: 'lg:grid-cols-5' };
  return `${n === 1 ? 'grid-cols-1' : 'grid-cols-2'} ${lg[n] ?? 'lg:grid-cols-5'}`;
}

export function Kpi({ label, value, sub, icon, loading, valueColor, delta }: {
  label: string; value: string; sub?: string; icon: React.ReactNode; loading?: boolean; valueColor?: string;
  /** Change vs a comparison, e.g. { pct: 12, label: 'vs last Fri' }. invert: going up is bad (labour %). unit defaults to '%'. */
  delta?: { pct: number; label: string; invert?: boolean; unit?: string } | null;
}) {
  const c = useAppColors();
  return (
    <div className="rounded-2xl p-4" style={{ background: c.bgElevated, border: `1px solid ${c.border}` }}>
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-bold uppercase tracking-widest" style={{ color: c.textFaint }}>{label}</span>
        <span style={{ color: c.iconColor }}>{icon}</span>
      </div>
      <p className="text-2xl font-semibold mt-2 leading-tight" style={{ color: valueColor ?? c.text }}>{loading ? '…' : value}</p>
      {sub && <p className="text-xs mt-1 truncate" style={{ color: c.textDim }}>{loading ? 'Loading' : sub}</p>}
      {!loading && delta && (
        <p className="text-xs mt-1 truncate font-semibold" style={{ color: delta.pct === 0 ? c.textDim : (delta.pct > 0) !== !!delta.invert ? c.accentSoft : RED }}>
          {delta.pct > 0 ? '▲' : delta.pct < 0 ? '▼' : '='} {Math.abs(delta.pct)}{delta.unit ?? '%'} <span className="font-normal" style={{ color: c.textFaint }}>{delta.label}</span>
        </p>
      )}
    </div>
  );
}

export function Section({ title, note, children }: { title: string; note?: string; children: React.ReactNode }) {
  const c = useAppColors();
  return (
    <section className="rounded-2xl p-5" style={{ background: c.bgElevated, border: `1px solid ${c.border}` }}>
      <div className="flex items-baseline justify-between mb-4 gap-3">
        <h2 className="text-base font-semibold" style={{ color: c.text }}>{title}</h2>
        {note && <span className="text-[11px]" style={{ color: c.textFaint }}>{note}</span>}
      </div>
      {children}
    </section>
  );
}

export function Empty({ text }: { text: string }) {
  const c = useAppColors();
  return <p className="text-sm py-10 text-center" style={{ color: c.textDim }}>{text}</p>;
}